import { useBoundContext } from "lib/@components/binding/use-bound-context"
import { AuthoringDeleteDialog } from "../plugins/project-item/authoring-delete-dialog"
import { useDialog } from "lib/@hooks/useDialog"
import { ContextMenuItem } from "lib/@components/context-menu-bar/context-menu-item"
import { errorSnackbar } from "lib/snackbar/error-snackbar"
import { successSnackbar } from "lib/snackbar/success-snackbar"
import { useParams } from "react-router"
import { deleteLegislationFromGroup } from "./controller/delete-legislation-from-group"
import { isLockedToLegacy } from "authoring/lib/enum/project-phase.mjs"

export function DeleteGroupLegislation() {
    const { reference, group, project } = useBoundContext()
    const { projectId, groupId } = useParams()
    const { legacyId, title } = reference
    const legislationId = parseInt(legacyId)

    const deleteLegislationDialog = useDialog(
        <AuthoringDeleteDialog
            value={legislationId}
            title="Delete legislation"
            message={`Are you sure you want to remove the following legislation from the group?\n\n${title}`}
            messageSx={{ whiteSpace: "pre-line" }}
        />
    )
    return (
        <ContextMenuItem
            icon="gravity-ui:trash-bin"
            label="Delete"
            onClick={() => removeLegislation({ projectId, groupId, legislationId, deleteLegislationDialog })}
            disabled={group.readOnly || isLockedToLegacy(project?.phase)}
        />
    )
}

async function removeLegislation({ projectId, groupId, legislationId, deleteLegislationDialog }) {
    try {
        const confirmRemove = await deleteLegislationDialog()
        if (confirmRemove) {
            const deleted = await deleteLegislationFromGroup({
                projectId,
                groupId,
                legislationIds: [legislationId],
            })
            if (deleted) {
                successSnackbar("Legislation successfully removed from group")
            } else {
                errorSnackbar("Failed to remove legislation from group")
            }
        }
    } catch (e) {
        errorSnackbar("Failed to remove legislation from group")
    }
}
